import React from 'react';
import PropTypes from 'prop-types';

const Flourish = ({ flourish }) => {
  React.useEffect(() => {
    const addScript = (url) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      document.querySelector('.flourish-embed').appendChild(script);
    };
    addScript('https://public.flourish.studio/resources/embed.js');
  });
  function cleanId(str) {
    const string = str.endsWith('/') ? str.slice(0, -1) : str;
    return string.replace('https://app.flourish.studio/', '')
      .replace('https://public.flourish.studio/', '')
      .replace('/edit', '')
      .replace('\'', '');
  }
  const id = cleanId(flourish);
  return (
    <div className="content">
      <div className="flourish-embed" data-src={id} />
    </div>
  );
};

Flourish.defaultProps = {
  flourish: {},
};

Flourish.propTypes = {
  flourish: {
    iframe: PropTypes.string.isRequired,
    divId: PropTypes.string,
  },
};

export default Flourish;
